import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import getQueryParam from 'syf-js-utilities/formats/getQueryParam';
import getAccessToken from '../../helpers/getAccessToken';
import Loader from './Loader';
const Callback = ({ apiHost, apigeeClientId, redirectUri, tokenPrefix = '', authorizedCallback, reAttemptAuthorization, successCallback, errorCallback, codeVerifierPrefix }) => {
    const handleCallback = async (authCode) => {
        const codeVerifier = codeVerifierPrefix
            ? sessionStorage.getItem(`${codeVerifierPrefix}-codeVerifier`)
            : sessionStorage.getItem('codeVerifier');
        // Re-attempting authorize only once to prevent infintite loop.
        const shouldReAttemptAuth = sessionStorage.getItem('retriedAuth') !== 'true';
        if (codeVerifier) {
            try {
                const { data: authResponse } = await getAccessToken({
                    baseURL: apiHost,
                    authCode,
                    clientId: apigeeClientId,
                    redirectURI: redirectUri,
                    codeVerifier
                });
                const { access_token: newAccessToken, session_id: correlationId } = authResponse;
                if (newAccessToken) {
                    sessionStorage.setItem(`${tokenPrefix}accessToken`, newAccessToken);
                    sessionStorage.setItem('correlationId', correlationId);
                    successCallback(authResponse);
                }
            }
            catch (error) {
                errorCallback(error);
                window.console.error(error);
            }
        }
        else if (shouldReAttemptAuth && reAttemptAuthorization) {
            sessionStorage.setItem('retriedAuth', 'true');
            reAttemptAuthorization();
        }
        else {
            errorCallback();
        }
    };
    useEffect(() => {
        const authCode = getQueryParam('code');
        if (authCode) {
            handleCallback(authCode);
        }
        else {
            authorizedCallback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return _jsx(Loader, {});
};
export default Callback;
